//should I copy entire cash Constatnts file over including feature flags?
import { ReasonCodesParams } from '@utils/weeklyMonthlyBalanceHelper';

import { SettlementType } from '@api/generator';

export const discrepancyAccountBpTpText = {
  BP: 'WB',
  TP: 'MB',
  BPTP: 'WB/MB',
};

export const discrepancySettlementText: Record<SettlementType, string> = {
  SettledToProfitLoss: 'Settle to P&L',
  SettledToCash: 'Settle to Cash',
  SettledToAccount: 'Settle to Account',
  SettledToNominee: 'Settle to assigned nominee',
  HelpRequested: 'Help requested',
  NoSettlement: 'No settlement',
};

export const cashMovementsHistoryReasonCode = {
  REASON_CODE_OUS: 'OUS',
  REASON_CODE_GWG: 'GWG',
  REASON_CODE_LP: 'LP',
  REASON_CODE_LOAN: 'Loan',
};

export const cashMovementsHistoryReasonLabel = {
  REASON_LABEL_OUS: 'Official Use Stamps',
  REASON_LABEL_GWG: 'Good Will Gesture',
  REASON_LABEL_LP: 'Local Purchase',
  REASON_LABEL_LOAN: 'Loan to POL',
};

export const SETTLED = 'Settled';
export const BACK_OFFICE = 'Back Office';
export const ALL = 'All';

export const reasonCodesParams: Record<string, ReasonCodesParams> = {
  TP: { reasonCode: 'TradingPeriod', reasonDescription: 'Trading Period' },
  BP: { reasonCode: 'BalancePeriod', reasonDescription: 'Balance Period' },
};

export const postActions: Record<string, string> = {
  create: 'Create',
};

export const WEEKLY_MONTHLY_HISTORY_SCREEN_STATE = 'WeeklyMonthlyBalanceHistoryScreenState';
export const maximumValueTransferAsPence = 10000000;
